
define(
    'FacetsCategoryCellListView.Extension',
    [
        'Facets.CategoryCell.View',
        'Backbone.CollectionView',
        'Facets.Browse.View',
        'Facets.FacetedNavigationItemCategory.View'
    ],
    function (
        FacetsCategoryCellView,
        BackboneCollectionView,
        FacetsBrowseView,
        FacetsFacetedNavigationItemCategoryView

    ) {
        'use strict';


        _.extend(FacetsBrowseView.prototype, {

            childViews: _.extend(FacetsBrowseView.prototype.childViews, {
                'Facets.CategoryCells': function () {
                    var shopCategories = [];
                    if (this.model.get('category')) {
                        shopCategories = this.model.get('category').get('categories');
                    } else {
                        shopCategories = [];
                    }

                    if (shopCategories) {
                        for (var i = 0; i < shopCategories.length; i++) {
                            var categoryText = (shopCategories[i].name).toLowerCase();
                            if (categoryText == "tools and accessories") {
                                shopCategories[i].canonical = "/tools-accessories";
                                shopCategories[i].fullurl = "/tools-accessories";
                                shopCategories[i].parenturl = "/";
                            } else if (categoryText == "silicone roof coatings") {
                                shopCategories[i].canonical = "/ge-enduris";
                                shopCategories[i].fullurl = "/ge-enduris";
                                shopCategories[i].urlfragment = "ge-enduris"
                                shopCategories[i].parenturl = "/";
                            } else {
                                var dewaltArray = categoryText.split(" ");
                                if (dewaltArray.length == 1) {
                                    if (categoryText.indexOf('dewalt') !== -1) {
                                        shopCategories[i].canonical = "/dewalt";
                                        shopCategories[i].fullurl = "/dewalt";
                                        shopCategories[i].parenturl = "/";
                                    }
                                }
                            }
                        }
                    }

                    return new BackboneCollectionView({
                        childView: FacetsCategoryCellView,
                        collection: shopCategories
                    });
                },

                'Facets.CategorySidebar': function () {
                    var categoryMenu = (this.model.get('category') && (this.model.get('category').get('siblings') || this.model.get('category').get('categories'))) || [];
                    for (var i = 0; i < categoryMenu.length; i++) {
                        var category = (categoryMenu[i].name).toLowerCase();
                        if (category == "tools and accessories") {
                            categoryMenu[i].canonical = "/tools-accessories";
                            categoryMenu[i].fullurl = "/tools-accessories";
                            categoryMenu[i].parenturl = "/";
                        } else if (category == "silicone roof coatings") {
                            categoryMenu[i].canonical = "/ge-enduris";
                            categoryMenu[i].fullurl = "/ge-enduris";
                            categoryMenu[i].parenturl = "/";
                        }
                    }
                    this.model.get('category').set('siblings', categoryMenu);

                    return new FacetsFacetedNavigationItemCategoryView({
                        model: this.model.get('category'),
                        categoryUrl: this.translator.getCategoryUrl()
                    });
                }
            })
        });
    });
